import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./UnlinkModal.module.css";
import ModalActionBar from "shared/ModalActionBar";
import { Modal } from "shared/Modal";
import CheckBoxItem from "../../Shared/CheckBoxItem";
import InfoItem from "shared/InfoItem";

/**
 * Interactive component. Modal used for unlinking an account.
 */

export function UnlinkModal({
  isOpen,
  onClose,
  onClick,
  memberID,
  dsId,
  // checked,
}) {
  const [isDeactivateChecked, setIsDeactivateChecked] = useState(false);

  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="UNLINK ACCOUNT"
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
      >
        <div className={styles.contentContainer}>
          <div className={styles.infoDiv}>
            <InfoItem label="WWG Membership ID:" description={memberID} />
          </div>
          <div className={styles.infoDiv1}>
            <InfoItem label="DreamStream ID:" description={dsId} />
          </div>
          <div className={styles.checkboxContainer}>
            <CheckBoxItem
              checked={isDeactivateChecked}
              name="Deactivate the account after unlinking"
              onClick={() => {
                setIsDeactivateChecked(!isDeactivateChecked);
              }}
            />
          </div>
        </div>
        <div className={styles.btnContainer}>
          <ModalActionBar
            children={
              <div className={styles.btnDiv}>
                <button
                  type="button"
                  className={styles.cancelBtn}
                  onClick={onClose}
                >
                  CANCEL
                </button>
                <button
                  type="button"
                  className={styles.unlinkBtn}
                  onClick={onClick}
                >
                  UNLINK
                </button>
              </div>
            }
          />
        </div>
      </Modal>
    </div>
  );
}

UnlinkModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Function called when create all is clicked
   */
  onClick: PropTypes.func,
  /**
   * WWG Membership ID
   */
  memberID: PropTypes.string,
  /**
   * DreamStream ID
   */
  dsId: PropTypes.string,
  /**
   * 	True if checkbox is checked
   */
  // checked: PropTypes.bool,
};
